import { render } from "./MenuGroup.vue?vue&type=template&id=76d3f68a"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuGroup.vue"]])

export default __exports__